// removed by extract-text-webpack-plugin
module.exports = {"hidden":"Ot5Dp","visuallyhidden":"_3rQno","hide-text":"_2Z91q","center":"exa_e","noprint":"_3yRbV","subsections":"_1PjCg","sectionLinks":"_25jdn","date":"_2GI0G","mainMobile":"_1Ab0J","mainDesktop":"_2_4AC","importantSectionsMenu":"_1p7LQ","importantSectionsItem":"_1twcp","importantSectionsLink":"zl9D0"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/MastheadExtensionBasicView.scss
 ** module id = 450
 ** module chunks = 0
 **/